import React from "react";

import { Edit, Eye } from "icons";

import { Button } from "clearsense-ui/components";
import convertToSelectOptions from "utils/convertToSelectOptions";

import { getUtcTime } from "../../utils";

export const NON_EDITABLE_FIELDS = [
  {
    fields: {
      npi_number: "NPI",
      caqh_providerid: "CAQH ID",
    },
    label: "Credentialing Request Details",
    value: "primary",
  },
];

export const TEMPLATE = {
  primary: {
    display_name: "Primary",
    value: [
      { label: "First Name", name: "fname", type: "text" },
      { label: "Middle Name", name: "mname", type: "text" },
      { label: "Last Name", name: "lname", type: "text" },
      { label: "Date of Birth", name: "dob", type: "date" },
      { label: "Gender", name: "gender", type: "text" },
      { label: "SSN", name: "ssn", type: "text" },
      {
        label: "Medicaid Number",
        name: "medicaid_no",
        type: "text",
      },
      {
        label: "Medicare Number",
        name: "medicare_no",
        type: "text",
      },
      {
        label: "Type Code",
        name: "provider_type_code",
        type: "text",
      },
      {
        label: "Provider Type Description",
        name: "provider_type_desc",
        type: "textarea",
      },
      {
        label: "Primary Speciality Description",
        name: "primary_specialty_desc",
        type: "textarea",
      },
      {
        label: "Secondary Speciality Description",
        name: "secondary_specialty_desc",
        type: "textarea",
      },
    ],
  },
  office: {
    display_name: "Office",
    value: [
      { label: "Office Name", name: "office_name", type: "text" },
      {
        label: "Address 1",
        name: "addr1",
        type: "text",
      },
      {
        label: "Address 2",
        name: "addr2",
        type: "text",
      },
      { label: "TIN", name: "tax_id", type: "text" },
      {
        label: "Is Primary?",
        name: "is_primary",
        type: "switch",
      },
    ],
  },
  board_certification: {
    display_name: "Board Certification",
    value: [
      {
        label: "Issuer Name",
        name: "issuer_name",
        type: "text",
      },
      {
        label: "Specialty Description",
        name: "spec_desc",
        type: "textarea",
      },
      {
        label: "Is Certified?",
        name: "is_certified",
        type: "switch",
      },
      {
        label: "Effective Date",
        name: "initial_cred_date",
        type: "date",
      },
      {
        label: "Expiration Date",
        name: "expiration_date",
        type: "date",
      },
    ],
  },
  state_lic: {
    display_name: "State License",
    value: [
      {
        label: "State License Board Name",
        name: "board_name",
        type: "text",
      },
      {
        label: "State License State",
        name: "state",
        type: "text",
      },
      {
        label: "State License Number",
        name: "license_number",
        type: "text",
      },
      {
        label: "State License Expiration Date",
        name: "expiration_date",
        type: "date",
      },
      {
        label: "State License Initial Credentialing Date",
        name: "initial_cred_date",
        type: "date",
      },
    ],
  },
  dea: {
    display_name: "DEA",
    value: [
      {
        label: "Certification State",
        name: "state",
        type: "text",
      },
      {
        label: "Certification Number",
        name: "cert_number",
        type: "text",
      },
      {
        label: "Certification Expiration Date",
        name: "expiration_date",
        type: "date",
      },
    ],
  },
  education: {
    display_name: "Education",
    value: [
      {
        label: "School Name",
        name: "school_name",
        type: "text",
      },
      {
        label: "Education Type Description",
        name: "edu_type_desc",
        type: "textarea",
      },
      {
        label: "Education Category Description",
        name: "edu_category_desc",
        type: "textarea",
      },
      {
        label: "Address 1",
        name: "addr1",
        type: "text",
      },
      {
        label: "Address 2",
        name: "addr2",
        type: "text",
      },
      {
        label: "Attn",
        name: "attn",
        type: "text",
      },
      {
        label: "City",
        name: "city",
        type: "text",
      },
      {
        label: "State",
        name: "state",
        type: "text",
      },
      {
        label: "ZIP",
        name: "zip",
        type: "text",
      },
      {
        label: "ECFMG ID Code",
        name: "ecfmg_id_code",
        type: "text",
      },
      {
        label: "Start Date",
        name: "start_date",
        type: "date",
      },
      { label: "End Date", name: "end_date", type: "date" },
      {
        label: "ECFMG Effective Date",
        name: "ecfmg_effective_date",
        type: "date",
      },
    ],
  },
  hospital: {
    display_name: "Hospital",
    value: [
      {
        label: "Hospital Name",
        name: "hospital_name",
        type: "text",
      },
      {
        label: "Is Primary?",
        name: "is_primary",
        type: "switch",
      },
      {
        label: "Is Restricted?",
        name: "is_restricted",
        type: "switch",
      },
      {
        label: "Privilege Type",
        name: "privilege_type",
        type: "text",
      },
    ],
  },
  insurance: {
    display_name: "Insurance",
    value: [
      {
        label: "Issuer Name",
        name: "issuer_name",
        type: "text",
      },
      {
        label: "Policy Number",
        name: "policy_number",
        type: "text",
      },
      {
        label: "Claim Limit",
        name: "claim_limit",
        type: "text",
      },
      {
        label: "Aggregate Limit",
        name: "aggregate_limit",
        type: "text",
      },
      {
        label: "Effective Date",
        name: "effective_date",
        type: "date",
      },
      {
        label: "Expiration Date",
        name: "expiration_date",
        type: "date",
      },
      {
        label: "Retro Date",
        name: "retro_date",
        type: "date",
      },
    ],
  },
  accreditation: {
    display_name: "Accreditation",
    value: [
      {
        label: "Certificate Number",
        name: "certificate_number",
        type: "text",
      },
      {
        label: "Accreditation Issuer Name",
        name: "issuer_name",
        type: "text",
      },
      {
        label: "Expiration Date",
        name: "expiration_date",
        type: "date",
      },
      {
        label: "Effective Date",
        name: "effective_date",
        type: "date",
      },
    ],
  },
  work_history: {
    display_name: "Work History",
    value: [
      {
        label: "History Name",
        name: "history_name",
        type: "text",
      },
      {
        label: "Start Date",
        name: "start_date",
        type: "date",
      },
      { label: "End Date", name: "end_date", type: "date" },
    ],
  },
};

export const HISTORY_COLUMNS = [
  {
    dataIndex: "user",
    key: "user_name",
    title: "Author",
    width: 150,
    ellipsis: true,
    render: val => `${val?.first_name} ${val?.last_name}`,
  },
  {
    dataIndex: "user",
    key: "user_email",
    title: "Author Email",
    width: 200,
    ellipsis: true,
    render: val => `${val?.email}`,
  },
  {
    dataIndex: "item_type",
    key: "item_type",
    title: "Table",
    width: 200,
    ellipsis: true,
  },
  {
    dataIndex: "event",
    key: "event",
    title: "Action",
    width: 100,
    ellipsis: true,
  },
  {
    dataIndex: "change_diff",
    key: "change_diff",
    title: "Changes",
    width: 300,
    render: val => {
      const changesAsString = Object.entries(val)
        .map(
          ([column, changes]) =>
            `${column}: ${changes[0] || "Nil"} => ${changes[1] || "Nil"}`
        )
        .join("\n");

      const changes = changesAsString.split("\n");
      const changesHTML = changes.map((change, index) => (
        <div key={index}>
          <b>{change.split(":")[0]}</b>
          <i>:{change.split(":")[1]}</i>
        </div>
      ));

      return changesHTML;
    },
  },
  {
    dataIndex: "created_at",
    key: "created_at",
    title: "Action Time",
    width: 240,
    render: val => getUtcTime(val),
  },
];

export const NPI_RECORDS_LIST_COLUMNS = [
  {
    dataIndex: "entity_key",
    key: "entity_key",
    title: "Entity Item Key",
    render: (_, rowData) => (
      <div className=" text-primary-shade">{rowData.entity_key}</div>
    ),
  },
  {
    dataIndex: "entity",
    key: "entity",
    title: "Entity",
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Status",
  },
  {
    dataIndex: "status_alter_time",
    key: "status_alter_time",
    title: "Status Update Time",
    render: val => getUtcTime(val),
  },
];

export const FIELD_TYPE = convertToSelectOptions(["text", "boolean", "date"], {
  isSort: false,
});

export const CREATE_TEMPLATE_INITIAL_VALUES = {
  name: "",
  entity: undefined,
  hierarchies: [
    {
      name: "",
      isEdit: true,
      isInitial: true,
      fields: [{ name: "", type: undefined, isEdit: true, isInitial: true }],
    },
  ],
};

export const TEMPLATE_COLUMNS = handleViewMoreDetails => [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
  },
  {
    dataIndex: "entity",
    key: "entity",
    title: "Entity",
  },
  {
    dataIndex: "action",
    key: "action",
    title: "Action",
    render: (_, row) => (
      <div className="flex gap-2">
        <Button
          label="View"
          icon={Eye}
          style="text"
          onClick={() => handleViewMoreDetails(row.id)}
        />
      </div>
    ),
  },
];

export const ASSOCIATIONS_COLUMNS = [
  {
    dataIndex: "id",
    key: "id",
    title: "No.",
    width: 75,
    render: (_1, _2, index) => index + 1,
  },
  {
    dataIndex: "direction",
    key: "direction",
    title: "Type",
  },
];

export const CREATE_ASSOCIATION_INITIAL_VALUES = {
  target_key: "",
  start_date: new Date().toISOString().slice(0, 10),
  end_date: "9999-12-31",
};

export const ENTITIES_COLUMN = handleEntityEdit => [
  {
    dataIndex: "name",
    key: "name",
    title: "Entity Name",
  },
  {
    dataIndex: "action",
    key: "action",
    title: "",
    render: (_, row) => (
      <div className="flex justify-end">
        <Button
          icon={Edit}
          iconSize={18}
          style="text"
          onClick={() => handleEntityEdit(row.id)}
        />
      </div>
    ),
  },
];
